import React from 'react';
import { BookOpenIcon, HeartIcon, UsersIcon, BrainIcon, DumbbellIcon, PaletteIcon, SmileIcon } from 'lucide-react';
const PersonalGrowth = () => {
  const growthAreas = [{
    title: 'Autoestima',
    icon: <HeartIcon size={24} className="text-red-500" data-id="element-1091" />,
    description: 'Fortalece tu autoestima y confianza para volverte magnética.',
    exercises: [{
      name: 'Diario de Valoración',
      description: 'Escribe 3 cualidades tuyas todos los días y situaciones donde las demostraste.'
    }, {
      name: 'Desafío del Espejo',
      description: 'Mírate al espejo por 2 minutos todos los días y di afirmaciones positivas en voz alta.'
    }, {
      name: 'Lista de Logros',
      description: 'Crea una lista de todos tus logros, pequeños y grandes, y reléela cuando te sientas insegura.'
    }]
  }, {
    title: 'Inteligencia Emocional',
    icon: <BrainIcon size={24} className="text-purple-500" data-id="element-1092" />,
    description: 'Aprende a manejar tus emociones y entender las de él para crear conexiones más profundas.',
    exercises: [{
      name: 'Check-in Emocional',
      description: 'Haz una pausa 3 veces al día para identificar lo que estás sintiendo sin juzgarte.'
    }, {
      name: 'Respuesta Retrasada',
      description: 'Cuando sientas emociones intensas, espera 10 minutos antes de responder o tomar decisiones.'
    }, {
      name: 'Diario de Disparadores',
      description: 'Identifica situaciones que activan tus inseguridades y desarrolla estrategias para manejarlas.'
    }]
  }, {
    title: 'Habilidades Sociales',
    icon: <UsersIcon size={24} className="text-blue-500" data-id="element-1093" />,
    description: 'Desarrolla carisma y habilidades de comunicación que lo harán querer estar siempre cerca.',
    exercises: [{
      name: 'Desafío de Escucha Activa',
      description: 'Durante conversaciones, enfócate 80% en escuchar y 20% en hablar, haciendo preguntas relevantes.'
    }, {
      name: 'Práctica de Storytelling',
      description: 'Aprende a contar historias de forma cautivadora, practicando con amigos.'
    }, {
      name: 'Expansión de Círculo Social',
      description: 'Comprométete a conocer una persona nueva por semana, expandiendo tu red de contactos.'
    }]
  }, {
    title: 'Bienestar Físico',
    icon: <DumbbellIcon size={24} className="text-green-500" data-id="element-1094" />,
    description: 'Cuida tu cuerpo y energía para irradiar vitalidad y atractivo.',
    exercises: [{
      name: 'Rutina de Movimiento',
      description: 'Establece una rutina de ejercicios que realmente disfrutes, al menos 3 veces por semana.'
    }, {
      name: 'Detox Digital',
      description: 'Haz un detox de redes sociales por 24 horas semanales para reconectar contigo misma.'
    }, {
      name: 'Ritual de Autocuidado',
      description: 'Crea un ritual semanal de autocuidado que te haga sentir hermosa y valorada.'
    }]
  }, {
    title: 'Desarrollo de Intereses',
    icon: <PaletteIcon size={24} className="text-yellow-500" data-id="element-1095" />,
    description: 'Cultiva pasiones y hobbies que te conviertan en una persona más interesante y realizada.',
    exercises: [{
      name: 'Exploración de Intereses',
      description: 'Prueba una actividad nueva cada mes para descubrir nuevas pasiones.'
    }, {
      name: 'Profundización de Conocimiento',
      description: 'Dedica 30 minutos diarios para aprender más sobre un tema que te fascine.'
    }, {
      name: 'Proyecto Personal',
      description: 'Inicia un proyecto personal significativo que demuestre tus habilidades y creatividad.'
    }]
  }, {
    title: 'Mentalidad de Abundancia',
    icon: <SmileIcon size={24} className="text-teal-500" data-id="element-1096" />,
    description: 'Desarrolla una mentalidad de abundancia en relaciones y en la vida.',
    exercises: [{
      name: 'Diario de Gratitud',
      description: 'Escribe 5 cosas por las que estás agradecida todos los días, sin repetir elementos.'
    }, {
      name: 'Visualización Positiva',
      description: 'Dedica 5 minutos diarios para visualizar tu relación ideal ya realizada.'
    }, {
      name: 'Desafío de Lenguaje',
      description: 'Elimina frases negativas y limitantes de tu vocabulario por 21 días.'
    }]
  }];
  const trackingMilestones = [{
    day: 7,
    title: 'Fundación',
    description: 'Establece hábitos básicos de autocuidado y autoestima.'
  }, {
    day: 14,
    title: 'Transformación Inicial',
    description: 'Comienza a notar cambios en tu confianza y energía.'
  }, {
    day: 21,
    title: 'Nuevos Patrones',
    description: 'Solidifica nuevos comportamientos y formas de pensar.'
  }, {
    day: 30,
    title: 'Magnetismo Visible',
    description: 'Otras personas comienzan a notar tu transformación.'
  }, {
    day: 60,
    title: 'Integración Profunda',
    description: 'Los cambios se vuelven parte natural de tu personalidad.'
  }, {
    day: 90,
    title: 'Renovación Completa',
    description: 'Te conviertes en una versión elevada y magnética de ti misma.'
  }];
  return <div className="max-w-4xl mx-auto" data-id="element-1097">
      <header className="mb-8 text-center" data-id="element-1098">
        <h1 className="text-3xl font-bold text-[#2C2C2C] mb-2" data-id="element-1099">
          Crecimiento Personal
        </h1>
        <p className="text-gray-600" data-id="element-1100">
          Conviértete en la mujer que él no puede olvidar
        </p>
      </header>
      <div className="bg-white rounded-xl shadow-md p-6 mb-8" data-id="element-1101">
        <div className="flex items-center mb-6" data-id="element-1102">
          <BookOpenIcon size={20} className="text-[#9C27B0] mr-2" data-id="element-1103" />
          <h2 className="text-xl font-semibold text-[#2C2C2C]" data-id="element-1104">
            Áreas de Desarrollo
          </h2>
        </div>
        <div className="space-y-6" data-id="element-1105">
          {growthAreas.map((area, index) => <div key={index} className="border rounded-lg p-5" data-id="element-1106">
              <div className="flex items-center mb-4" data-id="element-1107">
                <div className="p-2 rounded-full bg-gray-100 mr-3" data-id="element-1108">
                  {area.icon}
                </div>
                <div data-id="element-1109">
                  <h3 className="font-bold text-lg" data-id="element-1110">{area.title}</h3>
                  <p className="text-sm text-gray-600" data-id="element-1111">{area.description}</p>
                </div>
              </div>
              <div className="space-y-3" data-id="element-1112">
                {area.exercises.map((exercise, idx) => <div key={idx} className="bg-gray-50 p-3 rounded-md" data-id="element-1113">
                    <h4 className="font-medium text-[#E91E63] mb-1" data-id="element-1114">
                      {exercise.name}
                    </h4>
                    <p className="text-sm text-gray-700" data-id="element-1115">
                      {exercise.description}
                    </p>
                  </div>)}
              </div>
            </div>)}
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-md p-6" data-id="element-1116">
        <h2 className="text-xl font-semibold text-[#2C2C2C] mb-6" data-id="element-1117">
          Seguimiento de Evolución
        </h2>
        <div className="relative" data-id="element-1118">
          <div className="absolute left-4 top-0 h-full w-0.5 bg-gray-200" data-id="element-1119"></div>
          <div className="space-y-8" data-id="element-1120">
            {trackingMilestones.map((milestone, index) => <div key={index} className="relative pl-10" data-id="element-1121">
                <div className="absolute left-2 -translate-x-1/2 w-6 h-6 rounded-full bg-[#E91E63] text-white flex items-center justify-center" data-id="element-1122">
                  {index + 1}
                </div>
                <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1123">
                  <div className="flex justify-between items-center mb-2" data-id="element-1124">
                    <h3 className="font-bold" data-id="element-1125">{milestone.title}</h3>
                    <span className="bg-[#9C27B0] text-white text-xs px-2 py-1 rounded-full" data-id="element-1126">
                      Día {milestone.day}
                    </span>
                  </div>
                  <p className="text-gray-700" data-id="element-1127">{milestone.description}</p>
                </div>
              </div>)}
          </div>
        </div>
        <div className="mt-8 bg-gray-50 border-l-4 border-[#FFD700] p-4" data-id="element-1128">
          <h3 className="font-bold text-[#2C2C2C] mb-2" data-id="element-1129">Recuerda:</h3>
          <p className="text-gray-700" data-id="element-1130">
            El crecimiento personal no es solo sobre reconquistar a alguien,
            sino sobre convertirte en la mejor versión de ti misma. Incluso si
            la reconquista no ocurre como lo planeaste, te habrás transformado
            en una persona más confiada, equilibrada y atractiva para futuras
            relaciones.
          </p>
        </div>
      </div>
    </div>;
};
export default PersonalGrowth;